import { useFeedback } from "@/infrastructure/services/feedback";
import { Button, Icon, Icons, Span } from "@ir/ui";

const SidebarFeedback = () => {
  const { openFeedback } = useFeedback();

  return (
    <Button onPress={() => openFeedback()} variant="clear" color="primary" className="slide-navigation-item">
      <Icon name={Icons.MessageQuestionCircle} className="slide-navigation-icon" />
      <Span className="slide-navigation-label">Feedback</Span>
    </Button>
  );
};

export default SidebarFeedback;
